import React, { useEffect, useState,useRef } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ExportApi from "../api/ExportApi";
import Login from "./Login";
import states from "states-us";
import StripeElement from "./StripeElement";
import debounce from 'lodash.debounce';
import InputMask from "react-input-mask";
import WatchSvg from "../assets/svg/watchSvg";
import WalletSvg from "../assets/svg/walletSvg";
import { useAuthUser } from "../customHooks/useAuthUser";
import Loader from "../images/loader/loaderrrr.gif";

export default function Sonnet(props) {
  const loggedInUser = useAuthUser();
  const isLoggedInUserAdmin = loggedInUser?.role == "admin" ? true : false;
  const location = useLocation();
  const prams = useParams();
  const navigate = useNavigate();
  const [updateAskAmount, setUpdateAskAmount] = useState(
    location?.state?.askamount ? location.state?.askamount : 0
  );
  const [Show, setShow] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [signup, setSignup] = useState(true);
  const [askValue, setAskValue] = useState(0);
  const [Transction, setTransction] = useState(0);
  const [Payment, setPayment] = useState(0);
  const [total, settotal] = useState(0);
  const [Finalchecks, setFinalchecks] = useState();
  const [Finalchecks1, setFinalchecks1] = useState();
  const [Finalchecks2, setFinalchecks2] = useState();
  const [FinalchecksError, setFinalchecksError] = useState(false);
  const [Finalchecks1Error, setFinalchecks1Error] = useState(false);
  const [Finalchecks2Error, setFinalchecks2Error] = useState(false);
  const [expiration, setExpiration] = useState();
  const [input, setInput] = useState(false);
  const [sellNowStatus, setSellNowStatus] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [shippingFee, setShippingFee] = useState();
  const [fullPageLoader, setFullPageLoader] = useState(false);
  const [messageShown, setMessageShown] = useState(false);
  const [askStatus, setAskStatus] = useState(false);
  const [bid, setBid] = useState();

  const [cardExpiry, setCardExpiry] = useState("");
  const [cardBrand, setCardBrand] = useState("");
  const [carddetails, setCarddetails] = useState("");
  const [street, setStreet] = useState();
  const [subscribe, setSubscribe] = useState();
  const [validEmail, setValidEmail] = useState();
  const [city, setCity] = useState();
  const [country, setCountry] = useState();
  const [state, setState] = useState();
  const [postalCode, setPostalCode] = useState();
  const [shippingAddress, setShippingAddress] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [validStreet, setValidStreet] = useState();
  const [validCity, setValidCity] = useState();
  const [validState, setValidState] = useState();
  const [validcountry, setValidCountry] = useState("United States");
  const [validPostalCode, setValidPostalCode] = useState();
  const [validPhoneNumber, setValidPhoneNumber] = useState();
  const [buttonAddressLoader, setButtonAddressLoader] = useState(false);

  const [primaryAccountModel, setPrimaryAccountModel] = useState(false);

  const [mobileNumber, setMobileNumber] = useState();

  const [payoutLink, setPayoutLink] = useState();
  const [payoutBankName, setPayoutBankName] = useState();
  const [payoutCardNumber, setPayoutCardNumber] = useState();
  const [showPayoutModal, setShowPayoutModal] = useState(false);
  const [intialdata, setIntialdata] = useState();
  const [shippingrates, setShippingRates] = useState(null);
  const [estimatedShippingRateAsk , setEstimatedShippingRateAsk] = useState(false);
  const [shippingrateid, setShippingRateId] = useState();
  const [shipratesloader, setShipRatesLoader] = useState(false);
  const [placeOrderButtonLoader , setPlaceOrderButtonLoader] = useState(false)

  const [adminaddressid, setAdminaddressid] = useState();

  const [expiryDate, setExpiryDate] = useState(null); // This will store the combined expiry date
  const stateRef = useRef(null);
  const [rememberSelections, setRememberSelections] = useState(false);
  const isInitialLoad = useRef(true);
  const [payoutLoader , setPayoutLoader] = useState(false);

  // Constants for localStorage
  const SELECTIONS_STORAGE_KEY_PREFIX = "sonnet_user_selections";
  const SELECTIONS_VERSION = "1.0"; // Increment this when policies/wording change
  
  // Get storage key (global, not per URL)
  const getStorageKey = () => {
    return `${SELECTIONS_STORAGE_KEY_PREFIX}_global`;
  };

  //  const [isLoading, setIsLoading] = useState(false);

  // Function to create an order with the given product and user ID
  const handleCreateOrder = (productId, userId) => {
    // Display a loading indicator while creating the order.
    setLoading(true);
    // Call an API to create an order.
    ExportApi.createOrder(productId, userId, total)
      .then((resp) => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (prams.buy && prams.buy == "sell" && (!props.FinalPriceSell1 || props.FinalPriceSell1 == 0)) {
      navigate("/bidask/" + prams.slug);
      setShow(true);
    }
  }, [props.FinalPriceSell1])

  useEffect(() => {

    const restoreAskValues = () => {
      const storedData = localStorage.getItem("askSummary");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        handlePlaceAskValue(parsedData.askAmount);
      }
    };

    // run once on mount
    restoreAskValues();

    // run again after login
    window.addEventListener("handlingUserAction", restoreAskValues);

    return () => {
      window.removeEventListener("handlingUserAction", restoreAskValues);
      localStorage.removeItem("askSummary");
    };
  }, []);

  useEffect(() => {
    const fetchRates = async (amount) => {
      try {
        const resp = await ExportApi.getshipmentrates(loggedInUser?.id, amount, false, "ask");

        if (resp.data.success) {
          setShipRatesLoader(false);
          setShippingRates(resp?.data?.amount);
          setShippingRateId(resp?.data?.object_id);
          setAdminaddressid(resp?.data?.object_id);
          setEstimatedShippingRateAsk(false);
        }
        else {
          setShippingRateId(null);
          setShipRatesLoader(false);
          setShippingRates(12);
          setEstimatedShippingRateAsk(true);
        }

      } catch (error) {
        console.error(error, "rrrrt");
        setShipRatesLoader(false);
      } finally {
        setLoading(false);
      }
    };

    // Debounce function
    const debouncedFetchRates = debounce((amount) => {
      fetchRates(amount);
    }, 3000);  // Debounce with a delay of 500ms

    const amount = askValue;

    if (loggedInUser && loggedInUser?.role !== "admin" && amount && amount > 0) {
      setShipRatesLoader(true);
      setLoading(true);
      setEstimatedShippingRateAsk(false)
      debouncedFetchRates(amount);  // Call the debounced function
    } else if (loggedInUser && loggedInUser?.role == "admin" && amount && amount > 0) {
      setShipRatesLoader(false);
      setShippingRates(0);
      setEstimatedShippingRateAsk(false)
      handlePlaceAskValue(amount);
    } else if (!loggedInUser && amount && amount > 0) {
      setShipRatesLoader(false);
      setShippingRates(12);
      setShippingRateId(null);
      setEstimatedShippingRateAsk(true)
      handlePlaceAskValue(amount);
    }
    else {
      setShipRatesLoader(false);
      setShippingRates(null);
      setShippingRateId(null);
      setEstimatedShippingRateAsk(false)
    }

    return () => {
      debouncedFetchRates.cancel(); // Cancel debounce on cleanup
    };


  }, [askValue, loggedInUser]);
//[askValue, props?.Data]


  // Function to create a second-hand order with the given product ID, user ID, and askValue
  const handleCreateSecondHandOrder = (productId, userId, askValue) => {
    setLoading(true);
    // Call an API to create a second-hand order.
    ExportApi.CreateSecondHandOrderSell(
      productId,
      userId,
      props?.FinalPriceSell1,
      "Sell",
      props?.Askid ? props?.Askid : 0,
      shippingFeeToAdd,
      shippingrateid,
      TransctionToAdd,
      PaymentToAdd,
       
    )
      .then((resp) => {
        if (resp.data.success) {
          setLoading(false);
          navigate("/order");
          toast.success(resp.data.message)
        }
        else {
          setLoading(false);
          toast.error(resp.data.message);
          props.handleSearch();
          props.handleBid();
          props.handleAsk();
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
      });
  };

  //get the card Data
  const handleCardData = (id) => {
     if (!id) {
    console.warn("User ID is missing. Aborting operation.");
    return;
  }
    ExportApi.getCardData(id)
      .then((resp) => {
    
        let data = resp?.data?.data;
        setCarddetails(data)
        setCardBrand(data.brand);
        setCardExpiry(data.lastFour);
       

       
      })
      .catch((err) => {
        console.log(err);
      });
  };

 

  // Function to handle user bid

  const handleUserBid = (userid) => {
 

    if (props.error) { // always false
 
      toast.error(
        "Shipping Service not available Please Contact to Support Service22"
      );
    } else if (updateAskAmount) { // this condition will never work.
      if (updateAskAmount) {
      
       
        ExportApi.handleUpdateAsk(
          location?.state?.askId,
          userid,
          JSON.parse(askValue),
          JSON.parse(Transction),
          JSON.parse(Payment),
          total
        )
          .then((resp) => {
         
            if (resp.data.message == "Ask updated successfully") {
              window.dispatchEvent(new Event("List"));
              toast.success("Ask updated successfully");
              setLoading(false);
              setFullPageLoader(false);
              setAskValue(0);
              setUpdateAskAmount(0);
              navigate("/buySellManagment/selling");
            } else {
              setFullPageLoader(false);
              toast.error("Ask is not created! Something Went Wrong");
            }
          })
          .catch((err) => console.log(err));
      }
    } else {
      ExportApi.getSingleUserData(userid).then((resp) => {
        let data = resp.data.data;
        if (data?.shipping_address?.street != null) {
           if (prams.buy != undefined) {
              if (props.Data6 == 1) {
                setFullPageLoader(false);
                handleCreateOrder(props.productId, userid);
                navigate("/order");
              } else {
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1;
                const currentYear = currentDate.getFullYear();
              
                // Compare expiration date with the current date
               if (currentYear > carddetails.exp_year || (currentYear === carddetails.exp_year && currentMonth > carddetails.exp_month)) {
                // Card is expired
                    toast.error("Your card is expired. Please update your card.");
                    setLoading(false);
                    return
                } else {
                setFullPageLoader(false);
                handleCreateSecondHandOrder(props.productId, userid, askValue);}
              }
            } else {
              if (sellNowStatus) {
                if (props.Data6 == 1) {
                  setFullPageLoader(false);
                  handleCreateOrder(props.productId, userid);
                  navigate("/order");
                } else {
                  const currentDate = new Date();
                  const currentMonth = currentDate.getMonth() + 1;
                  const currentYear = currentDate.getFullYear();
                
                  // Compare expiration date with the current date
                 if (currentYear > carddetails.exp_year || (currentYear === carddetails.exp_year && currentMonth > carddetails.exp_month)) {
                  // Card is expired
                      toast.error("Your card is expired. Please update your card.");
                      setLoading(false);
                      return
                  } else {
                       // Card is valid                     
                  setFullPageLoader(false);
                  handleCreateSecondHandOrder(props.productId, userid, askValue);
                  navigate("/order");}
                }
              } else {
                setLoading(true);

const isAdmin = localStorage.getItem('admin');

// Set askValue conditionally
const finaltotal = isAdmin ? askValue : total;

                ExportApi.ask(
                  props.productId,
                  userid,
                  Transction,
                  Payment,
                  askValue,
                  finaltotal,
                  expiration,
                  shippingrates,
                  shippingrateid,
                  askExp
                )
                  .then((resp) => {
                    if (resp.data.success) {
                      window.dispatchEvent(new Event("List"));
                      toast.success("Ask created successfully");
                      setLoading(false);
                      setFullPageLoader(false);
                    } else {
                      setFullPageLoader(false);
                      //toast.error("Ask is not created! Something Went Wrong");
                      toast.error(resp?.data?.message);
                      setLoading(false);
                    }
                  })
                  .catch((err) => console.log(err));
              }
            }
        } else {
          toast.error("Please complete User information");
          // navigate(`/profile/${userid}`);
        }
      });
    }
  };

  // Function to handle bid submission
  const hendleBid = () => {
    // Check if URL ends with /sell
    const isSellPage = window.location.pathname.endsWith("/sell");
    if (!isSellPage && askValue == props?.Data2) {
      toast.error("Your ask matches the current bid. Please enter a different price.");
    } else {

      if (askStatus) {
        // Display an error toast if the ask is higher than the higher bid.
        toast.error("Your ask is higher than the higher bid");
      } else {
        setLoading(true);
        if (Finalchecks) {
          setFinalchecksError(false);
          if (Finalchecks1) {
            setFinalchecks1Error(false);
            if (Finalchecks2) {
              setFinalchecks2Error(false);
              if (localStorage.getItem("tokenuser")) {
                setLoading(false);
                if (input) {
                  setLoading(false);
                } else {
                  // Confirm the user's intent to create an order.
                  let confirm = window.confirm(
                    "Are you sure you want to create an order"
                  );
                  if (!confirm) {
                    // User canceled the operation.
                  } else {
                    // Call a function to handle user bid with their ID.
                    handleUserBid(JSON.parse(localStorage.getItem("tokenuser")).id);
                  }
                }
              } else if (localStorage.getItem("admin")) {
                setLoading(false);
                if (input) {
                  setLoading(false);
                } else {
                  // Confirm the user's intent to create an order.
                  let confirm = window.confirm(
                    "Are you sure you want to create an order"
                  );
                  if (!confirm) {
                    // User canceled the operation.
                  } else {
                    // Call a function to handle user bid with their ID.
                    handleUserBid(JSON.parse(localStorage.getItem("admin")).id);
                  }
                }
              } else {
                setShowModal(true);
              }
            } else {
              setLoading(false);
              setFinalchecks2Error(true);
              toast.error("Complete necessary checkboxes for seamless shopping");
            }
          } else {
            setLoading(false);
            setFinalchecks1Error(true);
            toast.error("Complete necessary checkboxes for seamless shopping");
          }
        } else {
          setLoading(false);
          setFinalchecksError(true);
          toast.error("Complete necessary checkboxes for seamless shopping");
        }
      }
    }
  };


  // Function to handle the input of the ask value
  const handlePlaceAskValue = (askValue) => {
    console.log(askValue , "askValue")
    // setting the raw value
    setAskValue(askValue);

    // setting the selling/transaction fee
    let transactionaskValue = (askValue * 0.095);
    setTransction(transactionaskValue.toFixed(2));

    // setting payout fee
    let paymentaskValue = (askValue * 0.03);
    setPayment(paymentaskValue.toFixed(2));

    // setting the total value
    let totalNumber;
    if (loggedInUser?.role == "admin") {
      totalNumber = askValue?.toFixed(2);
    } else {
      totalNumber = (
        Number(askValue) -
        Number(transactionaskValue) -
        Number(paymentaskValue) -
        Number(shippingrates)
      ).toFixed(2);
    }

    settotal(totalNumber);

    // other states
    setInput(false);
    if (Number(askValue) < props.Data2) {
      setAskStatus(true);
    } else {
      setAskStatus(false);
    }
  };

  // Function to handle "Sell Now" button click
  // const handleSellNow = (price) => {
  //   // Set various values based on the provided price.
  //   setSellNowStatus(true);
  //   setShow(false);
  //   setAskValue(price);
  //   let transactionaskValue = (price * 0.095);
  //   setTransction(transactionaskValue.toFixed(2));
  //   let paymentaskValue = (price * 0.03);
  //   setPayment(paymentaskValue.toFixed(2));
  //   let shippingCost = Number(0.5 / 100) * price;
  //   let fee = shippingCost;
  //   let sf = Number(props.shipping);
  //   // let shipping = (fee + sf)?.toFixed(2);
 
  //   setShippingFee(shippingrates);
  //   let totalNumber =
  //     Number(price) - (price * 0.03) - shippingrates - (price * 0.095);
  //   settotal(totalNumber.toFixed(2));
  //   // handleReviewAsk();
  // };

  // Function to handle the "Back" button click in the review step
  const handleReviewAsk = () => {
  // if (!payoutCardNumber) {
  //   toast.error("Please add a payout account first");
  //   return; 
  // }

    if (!shippingrateid) {
      toast.error("Please add shipping address first");
      return;
    }

    const calculatedValue =
    value !== undefined
      ? value - parseFloat(shippingrates) - value * 0.03 - value * 0.095
      : 0.00;
      setShippingFee(shippingrates);
      settotal(calculatedValue);
        if (calculatedValue < 0) {
    toast.error("Your net earnings after fees and shipping are negative. Please adjust your ask price.");
    return;
  }

    if (Number(askValue) <= 0) {
      toast.error("Please Input the Ask first");
      return;
    } else {
      if (Number(askValue) < props.Data2) {
        // If askValue is less than Data2, show an error toast.
        toast.error("Your Ask is less than the Highest Bid");
      } else {
 
        if (!loggedInUser) {
          setShowModal(true);
        } else if ( shippingAddress && askExp) {
          
          setShow(false);
          // props.update(false)
          // props.handleUserAsk1(false);
        } else {
          toast.error("Please fill all  the  user information");
        }
       
      }
    }
  };

  const handlebackAsk = () => {
    if (prams.buy) {
      setShow(true);
      navigate(-1);
    } else {
      setShow(true);
      props.update(true);
    }
  };


  // Function to handle validation for a checkbox
  const HandleFinalCheck = (askValue) => {
    if (askValue) {
      setFinalchecks(true);
      setFinalchecksError(false);
    } else {
      setFinalchecks(false);
      setFinalchecksError(true);
    }
  };
  // Another function to handle validation for a different checkbox
  const HandleFinalcheck1 = (askValue) => {
    if (askValue) {
      setFinalchecks1(true);
      setFinalchecks1Error(false);
    } else {
      setFinalchecks1(false);
      setFinalchecks1Error(true);
    }
  };
  // Another function to handle validation for a different checkbox
  const HandleFinalcheck2 = (askValue) => {
    if (askValue) {
      setFinalchecks2(true);
      setFinalchecks2Error(false);
    } else {
      setFinalchecks2(false);
      setFinalchecks2Error(true);
    }
  };

  // Save selections to localStorage
  const saveSelectionsToStorage = (shouldRemember = rememberSelections) => {
    // Only save if rememberSelections is true
    if (!shouldRemember) {
      return;
    }
    
    // Get current page URL (pathname + search params)
    const currentUrl = window.location.pathname + window.location.search;
    const storageKey = getStorageKey();
    
    const selections = {
      version: SELECTIONS_VERSION,
      url: currentUrl,
      noCancel: Finalchecks,
      accepted: Finalchecks1,
      shipWithin72: Finalchecks2,
      rememberSelections: shouldRemember,
      timestamp: Date.now()
    };
    localStorage.setItem(storageKey, JSON.stringify(selections));
  };

  // Load selections from localStorage
  const loadSelectionsFromStorage = () => {
    try {
      const storageKey = getStorageKey();
      const stored = localStorage.getItem(storageKey);
      if (!stored) return false;

      const selections = JSON.parse(stored);
      
      // Check if version matches (if version changes, don't restore)
      if (selections.version !== SELECTIONS_VERSION) {
        localStorage.removeItem(storageKey);
        return false;
      }

      // Restore Finalchecks (noCancel)
      if (selections.noCancel !== undefined) {
        setFinalchecks(selections.noCancel);
        if (selections.noCancel) {
          setFinalchecksError(false);
        }
      } else if (selections.Finalchecks !== undefined) {
        // Fallback to old field name for backward compatibility
        setFinalchecks(selections.Finalchecks);
        if (selections.Finalchecks) {
          setFinalchecksError(false);
        }
      }
      
      // Restore Finalchecks1 (accepted)
      if (selections.accepted !== undefined) {
        setFinalchecks1(selections.accepted);
        if (selections.accepted) {
          setFinalchecks1Error(false);
        }
      } else if (selections.Finalchecks1 !== undefined) {
        // Fallback to old field name for backward compatibility
        setFinalchecks1(selections.Finalchecks1);
        if (selections.Finalchecks1) {
          setFinalchecks1Error(false);
        }
      }

      // Restore Finalchecks2 (shipWithin72)
      if (selections.shipWithin72 !== undefined) {
        setFinalchecks2(selections.shipWithin72);
        if (selections.shipWithin72) {
          setFinalchecks2Error(false);
        }
      } else if (selections.Finalchecks2 !== undefined) {
        // Fallback to old field name for backward compatibility
        setFinalchecks2(selections.Finalchecks2);
        if (selections.Finalchecks2) {
          setFinalchecks2Error(false);
        }
      }
      
      if (selections.rememberSelections !== undefined) {
        setRememberSelections(selections.rememberSelections);
      }

      return true;
    } catch (error) {
      console.error("Error loading selections from storage:", error);
      const storageKey = getStorageKey();
      localStorage.removeItem(storageKey);
      return false;
    }
  };

  // Handle remember selections checkbox
  const handleRememberSelections = (checked) => {
    setRememberSelections(checked);
    
    if (checked) {
      // Save current selections when checkbox is checked
      // Pass the new checked value directly to ensure correct state
      setTimeout(() => saveSelectionsToStorage(checked), 0);
    } else {
      // Remove stored selections when unchecked
      const storageKey = getStorageKey();
      localStorage.removeItem(storageKey);
    }
  };





  const handleSingleUserData = async () => {
  try {
    const userToken = localStorage.getItem("tokenuser");
    const adminToken = localStorage.getItem("admin");

    const id = JSON.parse(userToken || adminToken)?.id;
    const phone = JSON.parse(userToken || adminToken)?.phone;

    const response = await ExportApi.getSingleUserData(id);
    const data = response?.data?.data;

    // Set address fields
    setStreet(data?.shipping_address?.street);
    setValidStreet(data?.shipping_address?.street);
    setCity(data?.shipping_address?.city);
    setValidCity(data?.shipping_address?.city);
    setState(data?.shipping_address?.state);
    setValidState(data?.shipping_address?.state);
    setCountry(data?.shipping_address?.country);
    setValidCountry(data?.shipping_address?.country);
    setPostalCode(data?.shipping_address?.postal_code);
    setValidPostalCode(data?.shipping_address?.postal_code);
    setPayoutLink(data?.accountLink);

    setIntialdata({
      street: data?.shipping_address?.street,
      city: data?.shipping_address?.city,
      country: data?.shipping_address?.country,
      postal_code: data?.shipping_address?.postal_code,
      state: data?.shipping_address?.state,
      phone: data?.phone,
    });

    // Set masked phone number
    if (phone) {
      const phoneStr = phone.toString();
      const masked = `(${phoneStr.slice(0, 3)})${phoneStr.slice(3, 6)}-${phoneStr.slice(6)}`;
      setMobileNumber(masked);
    } else {
      setMobileNumber(null);
    }

    // Handle card data
    handleCardData(id);
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

useEffect(() => {
  handleSingleUserData();
}, [loggedInUser]);

// Restore selections from localStorage on component mount
useEffect(() => {
  loadSelectionsFromStorage();
  // Mark initial load as complete after a short delay
  setTimeout(() => {
    isInitialLoad.current = false;
  }, 100);
}, []);

// Auto-save to localStorage when Finalchecks, Finalchecks1, Finalchecks2, or rememberSelections changes
useEffect(() => {
  // Skip saving on initial load (when restoring from localStorage)
  if (isInitialLoad.current) {
    return;
  }
  
  // Only save if rememberSelections is true
  if (rememberSelections) {
    // Use setTimeout to ensure state is fully updated before saving
    const timer = setTimeout(() => {
      saveSelectionsToStorage(true);
    }, 0);
    return () => clearTimeout(timer);
  }
}, [Finalchecks, Finalchecks1, Finalchecks2, rememberSelections]);


    // Function to mask mobile number
    const maskMobileNumber = (number) => {
      let numberString = number == null ? "" : number?.toString();
      if (numberString === "") return null;
    
      return `(${numberString.slice(0, 3)})${numberString.slice(3, 6)}-${numberString.slice(6)}`;
    };
  const fetchAndSetUserData = async () => {
    try {
      // Get user ID from localStorage, check if it's tokenuser or admin
      const user = localStorage.getItem("tokenuser")
        ? JSON.parse(localStorage.getItem("tokenuser"))
        : JSON.parse(localStorage.getItem("admin"));
      
      if (!user) {
        console.error("No user found in localStorage.");
        return;
      }
  
      const { id, phone } = user;
      
      // Fetch user data using the API
      const resp = await ExportApi.getSingleUserData(id);
      let Data = resp?.data?.data;
  
      // Update state variables with the fetched data
      setStreet(Data?.shipping_address?.street);
      setValidStreet(Data?.shipping_address?.street);
      setCity(Data?.shipping_address?.city);
      setValidCity(Data?.shipping_address?.city);
      setState(Data?.shipping_address?.state);
      setValidState(Data?.shipping_address?.state);
      setCountry(Data?.shipping_address?.country);
      setValidCountry(Data?.shipping_address?.country);
      setPostalCode(Data?.shipping_address?.postal_code);
      setValidPostalCode(Data?.shipping_address?.postal_code);
      setPayoutLink(Data?.accountLink);
  
      // Set mobile number (masking logic)
      const maskedNumber = maskMobileNumber(phone);
      setMobileNumber(maskedNumber);
  
      // Fetch additional card data
      handleCardData(id);
      
    } catch (err) {
      console.log("Error fetching user data:", err);
    }
  };
  
 
  
  // }, [askValue, props])


  useEffect(() => {
    if (prams.buy === "sell") {
          if (props.FinalPriceSell1) {
        // Set ask value based on props and calculate transaction, payment, and shipping fees.
     
        // return
        setAskValue(props.FinalPriceSell1);
        if (localStorage.getItem("tokenuser")) {
          var transactionaskValue = (props.FinalPriceSell1 * 0.095);
        } else if (localStorage.getItem("admin")) {
          var transactionaskValue = 0;
        } else {
          var transactionaskValue = (props.FinalPriceSell1 * 0.095);
        }
        // let transactionaskValue = (props.FinalPriceSell1 / 100) * 9.5;
        setTransction(transactionaskValue.toFixed(2));
        let paymentaskValue = (props.FinalPriceSell1 / 100) * 3;
        setPayment(paymentaskValue.toFixed(2));
        let shippingCost = Number(0.5 / 100) * props.FinalPriceSell1;
        let fee = shippingCost;
        let sf = Number(props.shipping);
        // let shipping = (fee + sf)?.toFixed(2);
      
        setShippingFee(shippingrates);
        
          let totalNumber;
          if (localStorage.getItem("admin")) {
            totalNumber = props.FinalPriceSell1 
          } else {
           totalNumber =
          Number(props.FinalPriceSell1) -
          (props.FinalPriceSell1 / 100) * 3 -
          Number(shippingrates) -
          transactionaskValue;
          }
        settotal(totalNumber);
        setShow(false);
      } else {
        // Set ask value based on props and calculate transaction, payment, and shipping fees.
        setAskValue(props.Data2);
        if (localStorage.getItem("tokenuser")) {
          var transactionaskValue = (props.Data2 * 0.095);
        } else if (localStorage.getItem("admin")) {
          var transactionaskValue = 0;
        } else {
          var transactionaskValue = (props.Data2 * 0.095);
        }
        // let transactionaskValue = (props.Data2 / 100) * 9.5;
        setTransction(transactionaskValue.toFixed(2));
        let paymentaskValue = (props.Data2 * 0.03);
        setPayment(paymentaskValue.toFixed(2));
        let shippingCost = Number(0.5 / 100) * props.Data2;
        let fee = shippingCost;
        let sf = Number(props.shipping);
        //let shipping = (fee + sf)?.toFixed(2);
  
        setShippingFee(shippingrates);
        
         
          let totalNumber;
          if (localStorage.getItem("admin")) {
            totalNumber = props.Data2
          } else {
            totalNumber =
            Number(props.Data2) -
            (props.Data2 * 0.03) -
            shippingrates -
            transactionaskValue;
           
          }
        settotal(totalNumber);
        setShow(false);
      }
    } 
    // else {
    //   setAskValue(updateAskAmount);
    //   if (localStorage.getItem("tokenuser")) {
    //     var transactionaskValue = (updateAskAmount * 0.095);
    //   } else if (localStorage.getItem("admin")) {
    //     var transactionaskValue = 0;
    //   } else {
    //     var transactionaskValue = (updateAskAmount * 0.095);
    //   }
    //   // let transactionaskValue = (updateAskAmount / 100) * 9.5;
    //   setTransction(transactionaskValue.toFixed(2));
    //   let paymentaskValue = (updateAskAmount * 0.03);
    //   setPayment(paymentaskValue.toFixed(2));

       

    //     let totalNumber;
    //     if (localStorage.getItem("admin")) {
    //       totalNumber = Number(updateAskAmount)
    //     } else {
    //       totalNumber =
    //       Number(updateAskAmount) -
    //     (updateAskAmount / 100) * 3 -
    //     shippingrates -
    //     transactionaskValue;
         
    //     }
    //   settotal(totalNumber);
    //   setShow(true);
    // }
  }, [prams]);

  const [askExp, setAskExp] = useState(30);
  const askExpiration = (e) => {
 
    setAskExp(e.target.value);
  };

  const handlePaymentEditClick = () => {
    if (localStorage.getItem("tokenuser")) {
      let userId = JSON.parse(localStorage.getItem("tokenuser"))?.id;
      
      window.location.replace(payoutLink);
      
    } else {
      setShowModal(true);
    }
 
  };



const handleEditPayouts = async () => {
  // Get tokenUser from localStorage
  const tokenUser = localStorage.getItem("tokenuser")|| localStorage.getItem("admin");

  // If tokenUser exists
  if (tokenUser) {
    // Parse the tokenUser data
    const parsedData = JSON.parse(tokenUser);

    // Get the stripe_account_id from tokenUser
    let stripeAccountId = parsedData?.account_id;
    // Check if stripe_account_id is undefined
    if (stripeAccountId === undefined) {
      let accountId = localStorage.getItem("account_id");
      
      // If account_id exists, proceed with the API call
      if (accountId) {
        try {
          const resp = await ExportApi.updateExpressStripeAccount(accountId);
          const data = resp.data.data;
        
          window.open(`${data?.url}`, "_self");
        } catch (err) {
          console.error(err, "err>>>>handleEditPayouts>>123");
        }
      } else {
        console.log("No Account_id found in localStorage");
  
      }
    } else {
      // If stripe_account_id exists, proceed with the API call
      try {
        const resp = await ExportApi.updateExpressStripeAccount(stripeAccountId);
        const data = resp.data.data;
 
        window.open(`${data?.url}`, "_self");
      } catch (err) {
        console.error(err);
      }
    }
  } else {
    setLoading(false);
  }
};

  const handleStripeAccountdsell = () => {
    // setIsLoading(true);
    let userId = JSON.parse(localStorage.getItem("tokenuser"));
  

    let pagename = "sellpage";

    ExportApi.handleCard(userId?.id, userId?.email, pagename)
      .then((resp) => {
        if (resp.data.message == "Account Created Successfully") {
          setShowPayoutModal(false);
          let data = resp.data.data;
     
          window.open(`${data.link}`, "_self");
          // setIsLoading(false);
        } else if (resp.data.message == "Account Already Exists") {
          setShowPayoutModal(false);
          toast.error("Email already exists");
          // setIsLoading(false);
        } else if (resp.data.message == "Account Updated Successfully"){
           setShowPayoutModal(false);
          let data = resp?.data?.data;
     
          window.open(`${data?.link}`, "_self");
        }
         else {
          toast.error(resp.data.message);
          setTimeout(() => {
            if (
              resp.data.message == "Add payment information to place an order"
            ) {
              navigate("/profile/" + userId?.id);
            } else {
              setShowPayoutModal(false);
              toast.error(resp.data.message);
              // setIsLoading(false);
            }
          }, 1000);
        }
      })
      .catch((err) => {
        setShowPayoutModal(false);
        // setIsLoading(false);
      });
  };
  const handleStripeAccount = () => {
    // setIsLoading(true);
    setPayoutLoader(true);
    if (!loggedInUser) {
      setShowModal(true);
      setPayoutLoader(false);
      return;
    }

    let pagename = "bidask";
    ExportApi.handleCard(loggedInUser?.id, loggedInUser?.email, pagename)
      .then((resp) => {
        setPayoutLoader(false);
        if (resp.data.message == "Account Created Successfully") {
          setShowPayoutModal(false);
          let data = resp.data.data;

          window.open(`${data.link}`, "_self");
        } else if (resp.data.message == "Account Already Exists") {
          setShowPayoutModal(false);
          toast.error("Email already exists");
        } else if (resp.data.message == "Account Updated Successfully") {
          let data = resp.data.data;

          window.open(`${data.link}`, "_self");
        } else {
          toast.error(resp.data.message);
          if (
            resp.data.message == "Add payment information to place an order"
          ) {
            navigate("/profile/" + loggedInUser?.id);
          } else {
            setShowPayoutModal(false);
            toast.error(resp.data.message);
          }
        }
      })
      .catch((err) => {
        setPayoutLoader(false);
        setShowPayoutModal(false);
      });
  };


  const handleEditClick = () => {
    if (localStorage.getItem("tokenuser")) {
      let userId = JSON.parse(localStorage.getItem("tokenuser"))?.id;
      const currentUrl = window.location.href;
      let sellid = currentUrl.split("/bidask/")[1].split("/")[0];
      const id = encodeURIComponent(sellid);
 
      let newlink = `https://connect.stripe.com/express/oauth/v2/authorize?response_type=code&client_id=ca_NzhOJRYQ0VEDugR4xgi0bmL5XuD24lxr&scope=read_write&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}?sendbidask=bidask`;
   

      window.location.replace(payoutLink);
      
    } else {
      setShowModal(true);
    }
 
  };

  const handleShippingAddressEditClick = () => {
    if (localStorage.getItem("tokenuser")  || localStorage.getItem("admin")) {
      let userId = JSON.parse(localStorage.getItem("tokenuser"))?.id;
      setShowAddressModal(true);
    
    } else {
      setShowModal(true);
      setShowAddressModal(false);
    }
  };

  //update the address
  const handleUpdateAddress = () => {
    setButtonAddressLoader(true);

    
let currentState = validState;
if (!currentState && stateRef.current) {
  currentState = stateRef.current.value;
  setValidState(currentState); // sync with state
}
    const validateField = (value, fieldName) => {
     if (!value?.trim()) {
       toast.error(`${fieldName} is required`);
       return false;
     }
     return true;
   };
   
   // Use this inside your `handleUpdateAddress`:
   if (
     !validateField(validStreet, "Street address") ||
     !validateField(validCity, "City") ||

     !validateField(currentState, "State")

   ) {
     setButtonAddressLoader(false);
     return;
   }

    if (!mobileNumber) {
      toast.error("Phone Number is Required");
      setButtonAddressLoader(false);
      return;
    }

    const newPhoneNumber = mobileNumber.toString().replace(/\D/g, ""); // Ensure mobileNumber is treated as a string before replace
    const postalCodeRegex = /^\d{5}(-\d{4})?$/;

    if (!postalCodeRegex.test(validPostalCode)) {
      toast.error('Postal Code must be 5 digits or in the format "12345" or "12345-6789"');
      setButtonAddressLoader(false);
      return;
    }
 
    // Check if the new address is the same as the current address
    if (
      intialdata.street == validStreet  &&
      intialdata.city == validCity  &&
      intialdata.state ==  currentState  &&

      intialdata.postal_code == validPostalCode  &&
      intialdata.phone ==   newPhoneNumber 
    ) {
      toast.error("Address is the same as the current address");
      setButtonAddressLoader(false);
      return;
    }

    // Proceed with updating the address if it has changed
    let id;
    if (localStorage.getItem("tokenuser")) {
      id = JSON.parse(localStorage.getItem("tokenuser"))?.id;
    } else {
      id = JSON.parse(localStorage.getItem("admin"))?.id;
    }

    ExportApi.updateSingleUserData(id, validStreet, validCity, currentState, validcountry, validPostalCode, newPhoneNumber)
      .then((resp) => {
         if (resp?.data.status == true){
        const Data = resp?.data?.result;

        setPostalCode(Data?.shipping_address?.postal_code);
        setCountry(Data?.shipping_address?.country);
        setState(Data?.shipping_address?.state);
        setCity(Data?.shipping_address?.city);
        setStreet(Data?.shipping_address?.street);
        localStorage.setItem("useraddress", JSON.stringify(validStreet));
        const newdata = {
          street: Data.shipping_address.street,
          city:Data?.shipping_address?.city,
          country:Data?.shipping_address?.country,
          postal_code:Data?.shipping_address?.postal_code,
          state:Data?.shipping_address?.state,
          phone:Data?.phone
        }
        setIntialdata(newdata);
        toast.success("Address Updated Successfully");
        setShowAddressModal(false);
        setButtonAddressLoader(false);
        setTimeout(() => {
          window.location.reload();
        },  2000);
       

        let localData;
        if (localStorage.getItem("tokenuser")) {
          localData = localStorage.getItem("tokenuser");
        } else {
          localData = localStorage.getItem("admin");
        }
        const parsedData = JSON.parse(localData);
        parsedData.phone = Data?.phone;
        if (localStorage.getItem("tokenuser")) {
          localStorage.setItem("tokenuser", JSON.stringify(parsedData));
        } else {
          localStorage.setItem("admin", JSON.stringify(parsedData));
        }
         }else{
           const errorDetails = resp?.data?.details?.[0]?.text || "Failed to update address";
         toast.error(errorDetails);  // 👈 shows message like: "Unable to validate street address line..."
           setButtonAddressLoader(false);

         }
      })
      .catch((err) => {
        setButtonAddressLoader(false);
        console.log(err);
      });
  };


  const tokenUser = localStorage.getItem("tokenuser");
  const adminUser = localStorage.getItem("admin");

  let userId;

  const useridnew = JSON.parse(tokenUser);
  const adminidnew = JSON.parse(adminUser);

  if (useridnew && useridnew.id) {
    userId = useridnew?.id;
  } else {
    userId = adminidnew?.id;
  }

  const handleStripConnectedCardData = () => {
    setLoading(true);
    ExportApi.getStripeCardData(userId)
      .then((resp) => {
         
        let data = resp?.data?.data?.data[0];
       
        let data2 = resp?.data;
        if (resp?.data?.data?.data?.length <= 0) {
       
          setPayoutCardNumber(data2?.last4);
          setPayoutBankName(data2?.brand);
        
          setLoading(false);
        } else {
          setPayoutCardNumber(data?.last4);
          setPayoutBankName(data?.bank_name);
        
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    handleStripConnectedCardData();
  }, [loggedInUser]);

   

  const askValueToAdd = isNaN(parseFloat(askValue)) ? 0 : parseFloat(askValue);

  const TransctionToAdd = isNaN(parseFloat(Transction))
    ? 0
    : parseFloat(Transction);

  const PaymentToAdd = isNaN(parseFloat(Payment)) ? 0 : parseFloat(Payment);

  const shippingFeeToAdd = isNaN(parseFloat(shippingrates))
    ? 0
    : parseFloat(shippingrates);

  let subtotal =
    askValueToAdd - TransctionToAdd - PaymentToAdd + shippingFeeToAdd;

   const isAdmin = localStorage.getItem('admin');
   const value = askValue && askValue !== 0 ? askValue : props?.Data;


  const calculatedValue = isAdmin
    ? value
    : value !== undefined
      ? value - parseFloat(shippingrates) - value * 0.03 - value * 0.095
      : 0.00;


  useEffect(() => {
    if (prams.buy && (prams.buy == "sell" || prams.buy == "buy")) {
      setShow(false);
    } else {
      setShow(true);
    }
  }, [location])

  return (
    <div>
      {fullPageLoader ? (
        <div className="loader-icon" style={{ marginBlock: "80px" }}>
          <i className="fa-solid fa-spinner fa-spin-pulse"></i>
        </div>
      ) : (
        <div>
          {Show ? (
              <div>
                {props.Data ? <p>Lowest Ask: $ {props.Data}</p> : ""}
                 {props.Data && props.Data != 0 && (
                    <div className="d-flex flex-row gap-1 align-items-center">
                    <p className="m-0 px-0" style={{ fontSize: "15px" }}>
                        {`To be the lowest ask  ->`}
                      </p>
                      <span className="px-3 py-1" onClick={() => handlePlaceAskValue(props.Data - 1)} style={{ fontSize: "12px" , cursor : "pointer" , backgroundColor : "#D7D5D5" , borderRadius : "8px"}}>
                        Ask ${props.Data - 1}
                      </span>
                    </div>
                  )
                  }
                <div className="d-flex  border rounded p-2 gap-2">
                 
                  <div className="quantity-custom">
                    <InputGroup className="mb-3">
                      <InputGroup.Text
                        id="basic-addon1"
                        className="bg-none border-end-0 text-dark"
                      >
                        $
                      </InputGroup.Text>
                      <Form.Control
                        value={askValue === 0 ? "" : askValue}
                        onChange={(e) => {
                          // Handle empty input scenario and prevent negative values
                          const value = e.target.value === '' ? '' : Math.max(0, e.target.value);
                          if (typeof value === "string" && value?.trim() == "") {
                            setAskValue()
                          }
                          else {
                            handlePlaceAskValue(value);
                          }
                        }}
                        placeholder="Enter Ask"
                        type="number"
                        className="border-start-0"
                        aria-label="number"
                        aria-describedby="basic-addon1"
                      />
                    </InputGroup>
                  </div>

                  <div className="ms-auto customsell-btn">
                    {
                      props.Data2 && (
                        <Button
                        style={{
                          fontWeight : 650
                        }}
                          className="sell-btn border-0 sell-button"
                          onClick={() => {
                            navigate("/bidask/" + prams?.slug + "/sell");
                          }}
                        >
                          Sell Now for ${props.Data2}
                        </Button>
                      )
                    }
                  </div>
              </div>
                {props.Data && askValue > 0 && (
                  <>
                    {
                      props.Data >= askValue ? (
                        <h2 className="text-capitalize text-center fs-4 my-4">
                          you are the lowest ask!
                        </h2>
                      ) : (
                        <h2 className="text-capitalize text-center fs-4 my-4">
                          you are not the lowest ask!
                        </h2>
                      )
                    }
                  </>
                )}

                <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                  <p className="mb-0">Your Ask</p>
                  <p className="ms-auto mb-0 truncated-number">
                    {askValue > 0 ? `$${askValue}` : "—"}
                  </p>
                </div>

                <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                  <p className="mb-0">Selling Fee (9.5%)</p>
                  {isLoggedInUserAdmin ? (
                    <p className="ms-auto mb-0">- $0</p>
                  ) : (
                    askValue > 0 ? (
                      <p className="ms-auto mb-0 truncated-number">- ${Transction}</p>
                    ) : (
                      <p className="ms-auto mb-0 truncated-number">—</p>
                    )
                  )}
                </div>

                <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                  <p className="mb-0">Payout Fee (3%)</p>
                  {isLoggedInUserAdmin ? (
                    <p className="ms-auto mb-0">- $0</p>
                  ) : (
                    askValue > 0 ? (
                      <p className="ms-auto mb-0 truncated-number">- ${Payment}</p>
                    ) : (
                      <p className="ms-auto mb-0 truncated-number">—</p>
                    )
                  )}
                </div>

                {
                  console.log(askValue , shipratesloader , "askValue > 0 && shipratesloader")
                }

                <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                  <p className="mb-0">Shipping {estimatedShippingRateAsk ? "(est)" : ""}</p>
                  {loggedInUser && isLoggedInUserAdmin && askValue > 0 ? (
                    <p className="ms-auto mb-0">$0</p>
                  ) : askValue > 0 && shipratesloader ? (
                    <p className="ms-auto mb-0 truncated-number">Loading...</p>
                  ) : askValue > 0 && !shipratesloader ? (
                    <p className="ms-auto mb-0">{isNaN(shippingrates) || shippingrates === undefined ? "—" : `- $${shippingrates?.toFixed(2)}`}</p>
                  ) : (
                    <p className="ms-auto mb-0">—</p>
                  )}
                </div>

                <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                  <p style={{fontWeight : 600}} className="mb-0"> Total Payout {estimatedShippingRateAsk ? "(est)" : ""}</p>
                  <p className="ms-auto mb-0 ">

                    {
                      loggedInUser && isLoggedInUserAdmin && askValue > 0 ? (
                        <p className="ms-auto mb-0 truncated-number">{`$${askValue}`}</p>
                      ) : askValue > 0 && shipratesloader ? (
                        <p className="ms-auto mb-0 truncated-number">loading...</p>
                      ) : askValue > 0 && !shipratesloader ? (
                        <p className="ms-auto mb-0 truncated-number">{isNaN(calculatedValue) || calculatedValue === undefined ? "—" : `$${calculatedValue.toFixed(2)}`}</p>
                      ) : (
                        <p className="ms-auto mb-0 truncated-number">—</p>
                      )
                    }

                  </p>
                </div>
                   {
                      estimatedShippingRateAsk && (
                        <p style={{fontWeight : 600, fontSize : "clamp(1rem, 1.4vw, 1rem)"}}>
                          Final Payout and Shipping confirmed after address
                        </p>
                      )
                    }


                {
                  loggedInUser ? (
                    <div class="border rounded p-2 ask-main">
                      <div class="ask-expiration d-flex">
                        <p class="mb-0">
                          <WatchSvg />
                          Ask Expiration
                        </p>
                        <div class="ms-auto">
                          <select
                            class="border py-1 px-2"
                            onChange={(e) => askExpiration(e)}
                          >
                            <option value="3">3 days</option>
                            <option value="7">7 days</option>
                            <option value="14">14 days</option>
                            <option selected value="30">
                              30 days
                            </option>
                            <option value="60">60 days</option>
                          </select>
                        </div>
                      </div>
                      <div className="payment-status">
                        <div class="ask-expiration d-flex mt-3">
                          <p class="mb-0">
                            <WalletSvg />
                            Payout method:{" "}
                            {payoutCardNumber ? (
                              <span>&nbsp;****{payoutCardNumber} </span>
                            ) : (
                              <span className="error-messages"></span>
                            )}
                          </p>
                          <div class="ms-auto">

                            {
                              payoutLoader ? (
                                <div className="flex justify-center items-center">
                                  <img src={Loader} alt="Loading..." style={{ height: '20px' }} />
                                </div>
                              ) : (
                                <>
                                  {payoutCardNumber ? (
                                    <button
                                      type="button"
                                      class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                      onClick={() => handleEditPayouts()}
                                    >
                                      edit
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                      onClick={() => handleStripeAccount()}
                                    >
                                      add
                                    </button>
                                  )}
                                </>
                              )
                            }
                          </div>
                        </div>

                        <div class="ask-expiration d-flex mt-3">
                          <p class="mb-0  d-flex align-items-center">
                            <WalletSvg />
                            <span>Payment method</span>&nbsp; : &nbsp;{" "}
                            {cardBrand && cardExpiry ? (
                              cardBrand + cardExpiry
                            ) : (
                              <span className="error-messages">Required</span>
                            )}
                            {/* {paymentStatus != 'null' ? 'Visa 4242' : <span className='text-danger fw-bold'>Required</span>} */}
                          </p>

                          {!props.paymentbtn ? (
                            <>
                              <div class="ms-auto">
                                <button
                                  type="button"
                                  class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                  onClick={() => {
                                    if (!localStorage.getItem("tokenuser")) {
                                      setShowModal(true);
                                    } else {
                                      setPrimaryAccountModel(true);
                                    }
                                  }}

                                //onClick={() => handlePaymentEditClicknew()}
                                >
                                  {" "}
                                  {!localStorage.getItem("tokenuser") ? (
                                    <>edit</>
                                  ) : (
                                    <>add</>
                                  )}
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div class="ms-auto">
                                <button
                                  type="button"
                                  class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                  onClick={() => props.handlePaymentEditClicknew("askTab")}
                                >
                                  edit
                                </button>
                              </div>
                            </>
                          )}

                        </div>

                        <div class="ask-expiration d-flex mt-3 ">
                          <p class="mb-0 d-flex align-items-start me-2">
                            <WalletSvg />
                            Shipping Address :&nbsp;
                            {street ? (
                              <div className="d-flex flex-column ms-3">
                                <p className="mb-0">{street}</p>
                                <p className="mb-0">{city}</p>
                                <p className="mb-0">{postalCode}</p>
                              </div>
                            ) : (
                              <span className="error-messages">Required</span>
                            )}
                            {/* {paymentStatus != 'null' ? '3864 Rhodes Ave' : <span className='text-danger fw-bold'>Required</span>} */}
                          </p>
                          <div class="ms-auto">
                            <button
                              type="button"
                              class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                              onClick={handleShippingAddressEditClick}
                            >
                              edit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                    :
                    (
                      <div class="border rounded p-2 ask-main">
                        <div class="ask-expiration d-flex flex-column justify-content-start">
                          <h5 style={{
                            fontWeight: 700
                          }}>
                            Sign up to buy or sell
                          </h5>
                          <p style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }} class="mb-0">
                            Required to place bids/asks and complete checkout
                          </p>
                        </div>
                      </div>
                    )
                }
              
            </div>
          ) : (
            <div className="review-part">
              {prams.buy != undefined ? (
                <h2 className="text-capitalize text-center fs-4 mt-4 mb-2">
                  Place Order
                </h2>
              ) : (
                <h2 className="text-capitalize text-center fs-4 mt-4 mb-2">
                  Place Ask
                </h2>
              )}
              <p className="text-center">
                Please confirm your {prams.buy != undefined ? "order" : "ask"}{" "}
                details below
              </p>
              <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                <p className="mb-0 text-capitalize">
                  {prams.buy != undefined ? "sale price" : "Your Ask"}
                </p>

                <p className="ms-auto mb-0">
                  {isNaN(askValue) || askValue <= 0 ? "—" : "$" + askValue}
                </p>
              </div>

                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    <p className="mb-0 text-capitalize">Selling Fee (9.5%) </p>
                    {isLoggedInUserAdmin ? (
                      <p className="ms-auto mb-0">$0</p>
                    ) : (
                      <p className="ms-auto mb-0">
                        {isNaN(Transction) ? "—" : "- $" + Transction}
                      </p>
                    )}
                  </div>

                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    <p className="mb-0 text-capitalize">Payout Fee (3%)</p>
                    {isLoggedInUserAdmin ? (
                      <p className="ms-auto mb-0">$0</p>
                    ) : (
                      <p className="ms-auto mb-0">
                        {isNaN(Payment) ? "—" : "- $" + Payment}
                      </p>
                    )}
                  </div>

                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    <p className="mb-0 text-capitalize">shipping</p>
                    {loggedInUser && isLoggedInUserAdmin ? (
                      <p className="ms-auto mb-0">$0</p>
                    ) : (
                      <p className="ms-auto mb-0">
                          {shipratesloader ? "Loading..." : (shippingrates !== undefined ? `-$${shippingrates}` : "—")}
                      </p>
                    )}
                  </div>

                  <div className="d-flex align-items-center  border-bottom pb-2 mb-3">
                    <p style={{fontWeight : 600}} className="mb-0 text-capitalize">Total Payout {estimatedShippingRateAsk ? "(est)" : ""}</p>
                    <p className="ms-auto mb-0 ">
                      {shipratesloader ? (
                        "Loading..."
                      ) : (
                        <p className="ms-auto mb-0 fw-bold">
                          {
                            isLoggedInUserAdmin
                              ? `$${askValue?.toFixed(2)}`
                              : (isNaN(calculatedValue) || calculatedValue === undefined)
                                ? "—"
                                : `$${calculatedValue.toFixed(2)}`
                          }
                        </p>
                      )}
                    </p>
                  </div>

                  {
                    loggedInUser ? (
                      <>
                        <div class="border rounded p-3 ask-main">
                          {prams.buy != undefined ? (
                            <></>
                          ) : (
                            <div class="ask-expiration d-flex">
                              <p class="mb-0">
                                <WatchSvg />
                                Ask Expiration
                              </p>
                              <div class="ms-auto">

                                {askExp} Day
                              </div>
                            </div>
                          )}
                          <div className="payment-status">
                            <div class="ask-expiration d-flex mt-3">
                              <p class="mb-0">
                                <WalletSvg />
                                Payout method :{" "}
                                {payoutBankName && payoutCardNumber ? (
                                  <span>&nbsp;****{payoutCardNumber} </span>
                                ) : (
                                  <span className="error-messages"></span>
                                )}
                              </p>
                              <div class="ms-auto d-flex">
                                {prams.buy != undefined ? (
                                  <div class="ms-auto">

                                    {payoutBankName ? (
                                      <button
                                        type="button"
                                        class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                        onClick={() => handleEditPayouts()}
                                      >
                                        edit
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                        onClick={() => handleStripeAccountdsell()}
                                      >
                                        add
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div class="ask-expiration d-flex mt-3">
                              <p class="mb-0  d-flex align-items-center">
                                <WalletSvg />
                                <span>Payment method</span>&nbsp; : &nbsp;{" "}
                                {cardBrand && cardExpiry ? (
                                  cardBrand + cardExpiry
                                ) : (
                                  <span className="error-messages">Required</span>
                                )}
                                {/* {paymentStatus != 'null' ? 'Visa 4242' : <span className='text-danger fw-bold'>Required</span>} */}
                              </p>

                              {!props.paymentbtn ? (
                                <>
                                  <div class="ms-auto">
                                    <button
                                      type="button"
                                      class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                      onClick={() => {
                                        if (!localStorage.getItem("tokenuser")) {
                                          setShowModal(true);
                                        } else {
                                          setPrimaryAccountModel(true);
                                        }
                                      }}

                                    //onClick={() => handlePaymentEditClicknew()}
                                    >
                                      {" "}
                                      {!localStorage.getItem("tokenuser") ? (
                                        <>edit</>
                                      ) : (
                                        <>add</>
                                      )}
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div class="ms-auto">
                                    <button
                                      type="button"
                                      class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                      //onClick={() => setPrimaryAccountModel(true)}
                                      onClick={() => props.handlePaymentEditClicknew("askTab")}
                                    >
                                      edit
                                    </button>
                                  </div>
                                </>
                              )}

                            </div>

                            <div class="ask-expiration  d-flex mt-3">
                              <p class="mb-0 d-flex align-items-start ">
                                <WalletSvg />

                                <p className="responsive-label">
                                  Return Shipping <span> Address :</span> &nbsp; </p>
                                {street ? (
                                  <>
                                    <div>

                                      <p className="mb-0">{street}</p>

                                      <p className="mb-0">{city}</p>

                                      <p className="mb-0">{postalCode}</p>

                                    </div>

                                  </>
                                ) : (
                                  <span className="error-messages">Required</span>
                                )}

                              </p>

                              {prams.buy != undefined ? (
                                <div class="ms-auto">
                                  <button
                                    type="button"
                                    class="text-uppercase edit-btn bg-transparent border-0 btn btn-primary"
                                    onClick={handleShippingAddressEditClick}
                                  >
                                    edit
                                  </button>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="pb-2 mb-3 mt-3 border rounded p-4">
                          <h5 className="mb-4">Pre Sale Acknowledgement</h5>

                          <p
                            className="d-flex align-items-start mb-0 pb-2 mb-2"
                            style={{ lineHeight: 1.3, fontSize: "14px" }}
                          >
                            <input
                              className="me-2"
                              type="checkbox"
                              style={{ marginTop: "2px" }}
                              checked={Finalchecks || false}
                              onChange={(e) => {
                                HandleFinalCheck(e.target.checked);
                              }}
                            />
                            <div>
                              <strong>Sales are binding</strong>
                              <br />
                              Once a buyer accepts my Ask or I use Sell Now, the order is created and the sale is binding. I'll only post Asks I can actually ship and I'll delete any Asks if I no longer have the card.
                            </div>
                          </p>

                          <hr />

                          <p className="d-flex align-items-start mb-0 pb-2 mb-2">
                            <input
                              className="me-2"
                              type="checkbox"
                              style={{ marginTop: "2px" }}
                              checked={Finalchecks1 || false}
                              onChange={(e) => {
                                HandleFinalcheck1(e.target.checked);
                              }}
                            />
                            <div style={{ lineHeight: 1.3, fontSize: "14px" }}>
                              <strong>Quality Standards (used & new)</strong>
                              <br />
                              The GPU I'm selling matches this model and meets GPUwiz {" "}
                              <a
                                target="_blank"
                                href="/help/quality-standards"
                                style={{ color: "#ff4400", textDecoration: "none" }}

                              >
                                Quality Standards.
                              </a>{" "}
                              (New (Resale) = factory sealed; Used (Tested) = performance and cosmetics.
                            </div>
                          </p>

                          <hr />

                          <p
                            className="d-flex align-items-start mb-0 pb-2 mb-2"
                            style={{ lineHeight: 1.3, fontSize: "14px" }}
                          >
                            <input
                              className="me-2"
                              type="checkbox"
                              style={{ marginTop: "2px" }}
                              checked={Finalchecks2 || false}
                              onChange={(e) => {
                                HandleFinalcheck2(e.target.checked);
                              }}
                            />
                            <div>
                              <strong>Ship within 72 hours</strong>
                              <br />
                              I'll ship the GPU using the GPUwiz prepaid label within 72 hours of order creation.
                            </div>
                          </p>


                          <p
                            className="mb-0 pb-2 mb-2"
                            style={{ lineHeight: 1.3, fontSize: "14px", paddingLeft: "20px" }}
                          >
                            Not following these rules (e.g., failing QA, not shipping, or cancelling after a match) may result in fees as described in the
                            <a
                              target="_blank"
                              href="/help/buying-and-Selling-Guide"
                              style={{ color: "#ff4400", textDecoration: "none" }}

                            >
                              {" "}Buying & Selling Guide{" "}
                            </a>
                            and
                            <a
                              target="_blank"
                              href="/terms"
                              style={{ color: "#ff4400", textDecoration: "none" }}

                            >
                              {" "}Terms
                            </a>
                            .
                          </p>

                          <p
                            className="mb-0 pb-2 mb-2"
                            style={{ lineHeight: 1.3, fontSize: "14px", paddingLeft: "20px" }}
                          >
                            Not sure if your card qualifies? Run a quick check first
                            {" "}
                            →<a
                              target="_blank"
                              href="/help/pre-sale-inspection-guide-2"
                              style={{ color: "#ff4400", textDecoration: "none" }}
                            >
                              {" "}Pre-Sale Inspection Guide{" "}
                            </a>
                          </p>

                        </div>
                        <p className="d-flex align-items-start mb-0 pb-2 mb-2 px-4" style={{ fontSize: "15px" }}>
                          <input
                            className="me-2 mt-1"
                            type="checkbox"
                            checked={rememberSelections}
                            onChange={(e) => {
                              handleRememberSelections(e.target.checked);
                            }}
                          />
                          Remember my selections on this device (optional)
                        </p>
                      </>
                    ) : (
                      <div class="border rounded p-2 ask-main">
                        <div class="ask-expiration d-flex flex-column justify-content-start">
                          <h5 style={{
                            fontWeight: 700
                          }}>
                            Sign up to buy or sell
                          </h5>
                          <p style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.3125rem)" }} class="mb-0">
                            Required to place bids/asks and complete checkout
                          </p>
                        </div>
                      </div>
                    )
                  }
            </div>
          )}

            {
              loggedInUser ? (
                <div className="d-flex align-items-center mt-3">
                  {!Show ? (
                    <Button
                      className="text-capitalize border rounded bg-transparent text-black"
                      onClick={() => handlebackAsk()}
                    >
                      back
                    </Button>//back button when the show is false
                  ) : (
                    null
                  )}

                  {Show ? (
                    shipratesloader ? (
                      <Button
                        className="text-capitalize ms-auto bg-dark text-white border-0 w-100"
                        
                        disabled
                      >
                        Loading...
                      </Button> // when shipmentloader and show is truw
                    ) : (

                      <Button
                        className="text-capitalize ms-auto bg-dark text-white border-0 w-100"
                        disabled={askValue <= 0 || shipratesloader}
                        onClick={handleReviewAsk}
                      >
                        Review Ask
                      </Button> // when shipmentloader is false show is true
                    )
                  ) : prams.buy != undefined ? ( // when there is no buy sell page
                    <Button
                      className="text-capitalize ms-auto bg-dark text-white border-0"
                      disabled={isLoading || shipratesloader || placeOrderButtonLoader}
                      onClick={() => {
                        setPlaceOrderButtonLoader(true)
                        hendleBid()
                        setPlaceOrderButtonLoader(false)
                      }}
                    >
                      {isLoading ? "Please Wait..." : "Place Order"}
                    </Button>
                  ) : (
                    <Button
                      disabled={isLoading}
                      className="text-capitalize ms-auto bg-dark text-white border-0"
                      onClick={() => hendleBid()}
                    >
                      {isLoading ? "Please wait..." : "Place Ask"}
                    </Button>
                  )}
                </div>
              ) :
                (
                  <div className="d-flex align-items-center mt-3">
                    <Button
                      className="text-capitalize ms-auto bg-dark text-white border-0 w-100"
                      onClick={() => {
                        const askSummary = {
                          askAmount: askValue ?? 0,
                          sellingFee: Transction ?? 0,
                          payoutFee: Payment ?? 0,
                          shipping: shippingrates ?? 0,
                          total: total ?? 0,
                        };

                        localStorage.setItem("askSummary", JSON.stringify(askSummary));

                        setShowModal(true);
                        setSignup(true);
                        setForgot(false);
                      }}
                    >
                      Sign Up
                    </Button>
                  </div>
                )
            }

            {/* Start Login Model */}
            <Login
              setSignup={setSignup}
              setForgot={setForgot}
              signup={signup}
              forgot={forgot}
              modal={() => setShowModal(false)}
              show={showModal}
              setShow={setShowModal} 
              windowEvent={true}
              />
            {/* End Login Model */}

          {/* Start Shipping Address */}
          <Modal
            show={showAddressModal}
            onHide={() => setShowAddressModal(false)}
            backdrop={true}
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Address</Modal.Title>
            </Modal.Header>
            <Modal.Body className="scrollable-modal-body">
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Your Address"
                  value={validStreet}
                  onChange={(e) => setValidStreet(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Your City"
                  value={validCity}
                  onChange={(e) => setValidCity(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>State</Form.Label>
               
                <Form.Select
                 ref={stateRef}
     aria-label="Select State"
  value={validState} // ✅ THIS LINE IS REQUIRED
  onChange={(e) => setValidState(e.target.value)}
>
  <option value="">Select State</option>
  {states?.map((item) => (
    <option key={item?.abbreviation} value={item?.abbreviation}>
      {item?.name}
    </option>
  ))}
</Form.Select>
              </Form.Group>
              
            
<Form.Group className="mb-3">
  <Form.Label>Country</Form.Label>
  <Form.Control
    type="text"
    value="United States"
    readOnly
    disabled
  />
</Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Postal Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Your Postal Code"
                  value={validPostalCode}
                  onChange={(e) => setValidPostalCode(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <InputMask
                  className="form-control"
                  mask="(999) 999-9999"
                  placeholder="(123) 456-7890"
                  type="tel"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                />
              
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                // onClick={() => setShowAddressModal(false)}
                onClick={() => {
                  setShowAddressModal(false);
                  fetchAndSetUserData();
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                disabled={buttonAddressLoader}
                onClick={handleUpdateAddress}
              >
                {buttonAddressLoader ? "Please Wait..." : "Save"}
              </Button>
            </Modal.Footer>
          </Modal>
          {/* End Shipping Address */}



          {/* Model start Primary Payment Account */}
          <Modal
            show={primaryAccountModel}
            size="lg"
            onHide={() => setPrimaryAccountModel(false)}
            backdrop={true}
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Primary Payment Account</Modal.Title>
            </Modal.Header>
            <Modal.Body className="scrollable-modal-body">
              <StripeElement cardBrand={cardBrand} productId={props.productId} />
            </Modal.Body>
          </Modal>
          {/* Model End Primary Payment Account */}
        </div>
      )}
    </div>
  );
}
